(function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function padIndex(num) {
    return num < 10 ? '0' + num : String(num);
  }

  function fadeCaption(elements, callback) {
    if (!elements.length || prefersReducedMotion) {
      if (callback) callback();
      return;
    }

    elements.forEach(function (el) {
      el.classList.add('is-fading');
    });

    window.setTimeout(function () {
      if (callback) callback();
      elements.forEach(function (el) {
        el.classList.remove('is-fading');
      });
    }, 150);
  }

  function initWorkspace(workspace) {
    if (!workspace || workspace.dataset.workspaceInitialized === 'true') return;
    workspace.dataset.workspaceInitialized = 'true';

    var cards = workspace.querySelectorAll('[data-erk-service-card]');
    var images = workspace.querySelectorAll('[data-erk-service-image]');
    var counter = workspace.querySelector('[data-erk-service-counter]');
    var captionTitle = workspace.querySelector('[data-erk-caption-title]');
    var captionText = workspace.querySelector('[data-erk-caption-text]');
    var prevBtn = workspace.querySelector('[data-erk-service-prev]');
    var nextBtn = workspace.querySelector('[data-erk-service-next]');
    var toggleBtn = workspace.querySelector('[data-erk-workspace-toggle]');
    var activeIndex = 0;

    function activate(index) {
      if (!cards.length) return;

      activeIndex = index;
      var card = cards[index];
      var id = card.dataset.erkServiceCard;

      cards.forEach(function (item, i) {
        var isActive = i === index;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      images.forEach(function (image) {
        var isActive = image.dataset.erkServiceImage === id;
        image.classList.toggle('is-active', isActive);
      });

      if (counter) {
        counter.textContent = padIndex(index + 1) + ' / ' + padIndex(cards.length);
      }

      var captionEls = [captionTitle, captionText].filter(Boolean);
      fadeCaption(captionEls, function () {
        if (captionTitle) {
          captionTitle.textContent = card.dataset.erkServiceTitle || '';
        }

        if (captionText) {
          captionText.textContent = card.dataset.erkServiceText || '';
        }
      });
    }

    cards.forEach(function (card, index) {
      card.addEventListener('click', function () {
        activate(index);
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        var nextIndex = activeIndex - 1;
        if (nextIndex < 0) nextIndex = cards.length - 1;
        activate(nextIndex);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        var nextIndex = activeIndex + 1;
        if (nextIndex >= cards.length) nextIndex = 0;
        activate(nextIndex);
      });
    }

    if (toggleBtn) {
      toggleBtn.addEventListener('click', function () {
        var expanded = toggleBtn.getAttribute('aria-expanded') === 'true';
        toggleBtn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        workspace.classList.toggle('is-collapsed-mobile', expanded);
      });
    }
  }

  function initServicing(root) {
    if (!root) return;
    root.querySelectorAll('[data-erk-workspace]').forEach(initWorkspace);
  }

  function initAll() {
    document.querySelectorAll('[data-erk-servicing]').forEach(initServicing);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-erk-servicing]');
    if (root) initServicing(root);
  });
})();
